import UltMeta, { Meta } from "./UltMeta/index";

class AccountsState extends UltMeta {
    UNSETTLED = new Meta(1, "未结清");

    DELAY = new Meta(2, "已逾期");

    SETTLED = new Meta(3, "已结清");
}
export const ACCOUNTS_STATE = new AccountsState();

class InventoryVertify extends UltMeta {
    USENUM = new Meta(1, "按数量/重量");
    USEMONEY = new Meta(2, "按金额");
}
export const INVENTORYVERIFY = new InventoryVertify();

class AccountsFields extends UltMeta {
    ID = new Meta(1, "应收款编号");
    PROJECT = new Meta(2, "关联项目");
    CONTRACT = new Meta(3, "关联合同");
    PAYMENT_UNIT = new Meta(4, "付款单位");
    RECEIVING_UNIT = new Meta(5, "收款单位");
    RECONCILIATION_ID = new Meta(6, "结算编号");
    ORDER_CODE = new Meta(7, "订单编号");
    PURCHASE_DATE = new Meta(8, "采购日期");
    SHOULD_AMOUNT = new Meta(9, "应收款金额（元）");
    RECEIVED_AMOUNT = new Meta(10, "已收款金额（元）");
    NOT_AMOUNT = new Meta(11, "未收款金额（元）");
    SETTLE_END_DATE = new Meta(12, "账期截止日期");
    DELAY_DATE = new Meta(13, "逾期时长（填）");
    CREATE_TIME = new Meta(14, "创建时间");
    STATE = new Meta(15, "状态");
    REFUNDED_AMOUNT = new Meta(16, "已退款金额（元）");
    DATA_SOURCES = new Meta(17, "数据来源");
    PLATFORM_PARTNERS = new Meta(18, "平台合作方");
}

export const ACCOUNTS_FIELDS = new AccountsFields();
